import React from 'react';
import { compose, filter, includes } from 'ramda';
import { reduxForm, InjectedFormProps, Form } from 'redux-form';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import WizardCard from 'components/WizardCard/WizardCard';
import Fields from 'components/Fields';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { PreviousStepType } from 'components/Wizard/Wizard';
import wizard from 'consts/wizard';
import IntlProvider, { useFormatMessage } from 'components/IntlProvider';

import { validate, wizardStyles } from './wizardUtils';

const { connect, selectors } = StoreProvider;

interface CountryType {
  name: string;
  code: string;
}

interface ProductAudienceCountryProps extends PreviousStepType {
  countries: CountryType[];
  setSubcategories: (data: object) => void;
}

const ProductAudienceCountry = ({
  handleSubmit,
  error,
  countries,
  previousStep,
}: ProductAudienceCountryProps & InjectedFormProps) => {
  const classes = wizardStyles();
  const t = useFormatMessage();

  return (
    <WizardCard>
      <Form onSubmit={handleSubmit} className={classes.form} noValidate>
        <Grid item xs={12}>
          <Typography
            component="h1"
            variant="h5"
            color="inherit"
            className={classes.title}
          >
            {t(
              'forms.wizard.productaudienceage',
              'For which target persons would you like to test your product?'
            )}
          </Typography>
          <Fields.Wizard.Country countries={countries} />
          {error && <FormHelperText error>{error}</FormHelperText>}
          <Button
            classes={{
              root: classes.submitButton,
            }}
            type="submit"
            variant="contained"
            color="primary"
          >
            {t('fields.wizard.common.continue', 'Continue')}
          </Button>
          <Button
            onClick={previousStep}
            classes={{
              root: classes.secondaryButton,
            }}
            color="secondary"
          >
            {t('fields.wizard.common.back', 'Back')}
          </Button>
        </Grid>
      </Form>
    </WizardCard>
  );
};

export default compose(
  IntlProvider.withIntl,
  connect((state) => ({
    countries: compose(
      filter(({ code }: CountryType) =>
        includes(code, wizard.PERMITTED_COUNTRIES_CODE)
      )
    )(selectors.assistantSelectors.countries(state)),
  })),
  reduxForm({
    form: 'wizard',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate,
  })
)(ProductAudienceCountry);
